<template>
  <v-page page="scoringModel" title="Scoring Model">
    <v-container class="px-0 mx-0 pt-1 mt-3">
      <v-layout>
        <v-flex>
          <v-layout>
            <v-flex>
              <v-text-field v-model="query"
                            placeholder="Search"
                            clearable solo
                            @keydown.enter="search"
                            data-test="searchInput"></v-text-field>
            </v-flex>
            <v-flex xs2 class="ml-2">
              <v-select v-model="attribute"
                        :items="searchAttributeChoices"
                        @change="search" solo></v-select>
            </v-flex>
            <v-flex class="searchbar-btn" xs2 lg1 ml-2>
              <v-btn @click="search" color="primary">Search</v-btn>
            </v-flex>
          </v-layout>
          <v-toolbar flat color="#FAFAFA" class="update-action pb-1">
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-dialog v-model="dialog" persistent max-width="500">
                <template v-slot:activator="{ on }">
                  <v-btn small color="primary" dark v-on="on">
                    <v-icon left>
                      {{ buttonIcon }}
                    </v-icon>
                      {{ buttonText }}
                  </v-btn>
                </template>
                  <v-card>
                    <v-flex offset-xs3>
                      <v-card-title class="headline">Create Score Model</v-card-title>
                    </v-flex>
                    <v-flex sm9 offset-xs1>
                      <v-text-field
                                v-model="model.name"
                                maxlength="128"
                                placeholder="Name">
                      </v-text-field>
                    </v-flex>
                    <v-flex sm9 offset-xs1>
                      <v-text-field
                                v-model="model.version"
                                maxlength="64"
                                placeholder="Version">
                      </v-text-field>
                    </v-flex>
                    <v-flex sm9 offset-xs1>
                      <v-text-field
                                v-model="model.type"
                                maxlength="64"
                                placeholder="Type">
                      </v-text-field>
                    </v-flex>
                    <v-flex sm9 offset-xs1>
                      <v-text-field
                                v-model="model.image_tag"
                                maxlength="64"
                                placeholder="Image Tag">
                      </v-text-field>
                    </v-flex>
                    <v-flex sm9 offset-xs1>
                      <v-select
                              v-model="model.is_experimental"
                              :items="statusAttributeChoices"
                              placeholder="Is Experimental"
                              flat>
                      </v-select>
                    </v-flex>
                    <v-flex offset-xs6 pl-4 pt-3 pb-1>
                      <v-layout>
                        <v-btn color="secondary" @click="() => {dialog = false; this.clear()}" class="d-flex mr-2">Cancel</v-btn>
                        <v-btn @click="createUpdateModel" color="primary" :disabled="this.isInvalidEntry">Confirm</v-btn>
                      </v-layout>
                    </v-flex>
                  </v-card>
                </v-dialog>
              </v-toolbar-items>
            </v-toolbar>
          <v-layout>
            <v-flex>
              <v-data-table
                        :headers="tableHeaders"
                        must-sort
                        no-data-text="No scoring models corresponding to your search"
                        :loading="loading"
                        :items="scoringModels"
                        class="elevation-4">
                <template slot="no-data">
                  <div class="text-xs-center py-2">
                      No results
                  </div>
                </template>
                <template v-slot:item="props">
                  <tr :active="props.selected" @click="rowSelected(props)">
                    <td>
                      <v-radio-group
                        v-model="selected"
                        name="rowSelector">
                        <v-radio class="pt-3 mt-1" :value="props.item.id"/>
                      </v-radio-group>
                    </td>
                    <td> {{ props.item.id }} </td>
                    <td> {{ props.item.name }} </td>
                    <td> {{ props.item.version }} </td>
                    <td> {{ props.item.type }} </td>
                    <td> {{ props.item.image_tag }} </td>
                    <td> {{ props.item.is_experimental | booleanYesNo }} </td>
                    <td> {{ props.item.build_date | dateTime}} </td>
                    <td> {{ props.item.expires_at | dateTime}} </td>
                    <td> {{ props.item.created_at | dateTime}} </td>
                    <td> {{ props.item.updated_at | dateTime}} </td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-page>
</template>
<script>
import VPage from '@/layouts/Default'
import { Bus } from '@/bus'
import moment from 'moment'

export default {
  name: 'ScoringModel',
  components: {
    VPage
  },
  data () {
    return {
      query: '',
      dialog: false,
      selected: null,
      attribute: 'names',
      model: {
        'id': '',
        'name': '',
        'version': '',
        'type': '',
        'image_tag': '',
        'is_experimental': null
      },
      statusAttributeChoices: [
        { value: true, text: 'True' },
        { value: false, text: 'False' }
      ],
      searchAttributeChoices: [
        { value: 'names', text: 'Names' },
        { value: 'types', text: 'Types' },
        { value: 'ids', text: 'Ids' }
      ],
      tableHeaders: [
        { text: 'Select' },
        { text: 'Model Id', value: 'id', sortable: true },
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Version', value: 'version', sortable: true },
        { text: 'Type', value: 'type', sortable: true },
        { text: 'Image Tag', value: 'image_tag', sortable: true },
        { text: 'Is Experimental', value: 'is_experimental', sortable: true },
        { text: 'Build Date', value: 'build_date', sortable: true },
        { text: 'Expires At', value: 'expires_at', sortable: true },
        { text: 'Created Date', value: 'created_at', sortable: true },
        { text: 'Updated Date', value: 'updated_at', sortable: true }
      ],
      scoringModels: [],
      loading: false,
      buttonText: 'Add Model',
      buttonIcon: 'add'
    }
  },
  mounted () {
    this.search()
  },
  computed: {
    isInvalidEntry () {
      if (this.model.name !== '' && this.model.version !== '' && this.model.type !== '') {
        return false
      }

      return true
    },
    isEntryValid () {
      return this.model.name !== '' && this.model.version !== '' && this.model.type !== '' && this.model.is_experimental !== null && this.model.image_tag !== ''
    }
  },
  methods: {
    search () {
      this.loading = true
      var data = {}
      if (this.query !== '') {
        data[this.attribute] = this.query
      }
      this.$store.dispatch('scores/fetchScoringModels', data)
        .then(response => {
          this.scoringModels = response
        })
        .catch(() => {
          Bus.$emit('alert', { color: 'error', message: 'Failed to retrieve scoring models' })
        })
        .finally(() => {
          this.loading = false
        })
    },
    createUpdateModel () {
      this.loading = true

      if (this.isEntryValid && !this.selected) {
        this.model['build_date'] = moment()
        this.$store.dispatch('scores/createScoringModel', [this.model]) // Create sent
          .then(response => {
            Bus.$emit('alert', { color: 'success', message: 'Successfully created model' })
          })
          .catch(() => {
            Bus.$emit('alert', { color: 'error', message: 'Failed to create scoring model' })
          })
      } else if (this.isEntryValid && this.selected) {
        if (!this.model.is_experimental) { // Update auto fail due to quartile not existing
          this.$store.dispatch('scores/retrieveQuartiles', { 'model_name': this.model['name'] })
            .then(response => {
              if (response['quartiles'].length === 0) {
                Bus.$emit('alert', { color: 'error', message: 'Cannot create or update model that is experimental due to quartiles not existing' })
                this.loading = false
              }
            })
            .catch(() => {
              Bus.$emit('alert', { color: 'error', message: 'Failed to retrieve quartiles for validation check ' })
            })
        }

        this.$store.dispatch('scores/updateScoringModel', this.model) // Update sent
          .then(response => {
            Bus.$emit('alert', { color: 'success', message: 'Successfully updated model' })
          })
          .catch(() => {
            Bus.$emit('alert', { color: 'error', message: 'Failed to update scoring model' })
          })
      } else { // Missing fields auto fail
        Bus.$emit('alert', { color: 'error', message: 'Required fields missing' })
        this.loading = false
        return
      }

      this.clear()
    },
    rowSelected (row) {
      if (this.model === row.item) {
        this.clear()
      } else if (this.selected) {
        this.model = row.item
        this.buttonText = 'Edit Model'
        this.buttonIcon = 'edit'
      }
    },
    clear () {
      this.model = {
        'id': '',
        'name': '',
        'version': '',
        'type': '',
        'image_tag': '',
        'is_experimental': null
      }
      this.selected = null
      this.buttonText = 'Add Model'
      this.buttonIcon = 'add'
      this.dialog = false
      this.loading = false
      this.query = ''
      this.attribute = 'names'
    }
  }
}
</script>
<style lang="sass">
  .v-btn:not(.v-btn--round).v-size--small
    max-height: 45px

</style>
